import { useState, useEffect } from 'react';
import { fetchGeolocation } from '../services/api';

/**
 * Custom hook to fetch and manage geolocation data
 * @returns {Object} Geolocation state and data
 */
export const useGeolocation = () => {
  const [geolocationData, setGeolocationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadGeolocation = async () => {
      try {
        setLoading(true);
        const result = await fetchGeolocation();
        
        if (result.success) {
          setGeolocationData(result.data);
        } else {
          setError(result.error || 'Failed to fetch geolocation');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadGeolocation();
  }, []);

  return {
    geolocationData,
    loading,
    error,
    country: geolocationData?.countryName || '',
    countryCode: geolocationData?.countryCode || 'US',
    city: geolocationData?.cityName || '',
    state: geolocationData?.regionName || '',
    ipAddress: geolocationData?.ipAddress || ''
  };
};

export default useGeolocation;
